import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import HelperMixin from "@/mixins/HelperMixin";
import AppPopover from "@/components/AppPopover";
import AppIcon from "@/components/AppIcon";
import { CurrencyValue } from "@/components/tableElements";
import PpcBudgetAllocationWeeklyBudgetEdit from "@/components/PpcBudgetAllocationWeeklyBudgetEdit";
import TasksMixin from "@/mixins/TasksMixin.vue";
import AppModal from "@/components/AppModal";
import PauseIcon from "@/components/icons/PauseIcon.vue";
import PpcCampaignGroupInfo from "@/components/PpcCampaignGroupInfo.vue";
import PpcBABudgetCell from "@/components/PpcBABudgetCell.vue";
import PpcBAMaxPotentialPercentCell from "@/components/PpcBAMaxPotentialPercentCell.vue";
import PpcBAVsLastWeekSpendCell from "@/components/PpcBAVsLastWeekSpendCell.vue";
import PpcBABlockCell from "@/components/PpcBABlockCell.vue";
import PpcBAStateCell from "@/components/PpcBAStateCell.vue";
import PpcBAProductInfoCell from "@/components/PpcBAProductInfoCell.vue";
import PpcBAPrioritizedByCell from "@/components/PpcBAPrioritizedByCell.vue";
import PpcBAProductMarginCell from "@/components/PpcBAProductMarginCell.vue";
import PpcBAAcosRoasCell from "@/components/PpcBAAcosRoasCell.vue";
import PpcBABoostCell from "@/components/PpcBABoostCell.vue";
import PpcSPProductAds from "@/components/PpcSPProductAds.vue";
import PpcInconsistentStatePopover from "@/components/PpcInconsistentStatePopover.vue";
import { EVENTS, isSubset } from "@/utils";
import { currencies_symbols } from '@/utils/currencies';
import AccountsMixin from "@/mixins/AccountsMixin.vue";
export default {
  name: "PpcBudgetAllocationItem",
  emits: ["item-update", "weekly-budget-edit"],
  mixins: [HelperMixin, TasksMixin, AccountsMixin],
  components: {
    AppPopover,
    AppIcon,
    AppModal,
    PpcBudgetAllocationWeeklyBudgetEdit,
    CurrencyValue,
    PauseIcon,
    PpcCampaignGroupInfo,
    PpcBABudgetCell,
    PpcBAMaxPotentialPercentCell,
    PpcBAVsLastWeekSpendCell,
    PpcBABlockCell,
    PpcBAStateCell,
    PpcBAProductInfoCell,
    PpcBAPrioritizedByCell,
    PpcBAProductMarginCell,
    PpcBAAcosRoasCell,
    PpcBABoostCell,
    PpcSPProductAds,
    PpcInconsistentStatePopover
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: ""
    },
    weeklyBudgetTarget: {
      type: String,
      default: null
    },
    last: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String
    },
    selected_profile_id: {
      type: String
    },
    selected_seller: {
      type: Object
    },
    still_initializing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currency_precision: 0,
      weeklyBudgetShown: null,
      calculatedCapForMode: {
        acos: this.aCOSCap,
        roas: this.rOASCap
      },
      badgeTextMapping: {
        activated: "Newly activated",
        paused: "Paused",
        inactive: "Inactive",
        updated: ""
      },
      campaignEditTaskIdentifier: "",
      edit_campaign_loading: false,
      edit_campaign_type: "",
      updated_budget: {},
      changeModal: false,
      updated_campaign_group_state: "",
      change_modal_text: "",
      change_modal_type: "",
      change_modal_data_type: "",
      confirmBlockModalOkMap: {
        block: this.onBlock,
        state: this.onApplyStateConfirm,
        budget_update: this.onApplyBudgetConfirm
      }
    };
  },
  mounted() {
    this.campaignEditTaskIdentifier = this.current_workspace.workspace_id + "_" + this.item.campaign_group_id + "_" + "ppc_edit_campaign";
    this.checkIfAnyPreviousUpdateTaskIsRunning();
  },
  computed: {
    ...mapState({
      bid_settings: state => state.ppc_settings.bid_settings,
      current_workspace: state => state.workspace.current_workspace,
      sp_product_ads_by_campaign_id: state => state.ppc_settings.sp_product_ads_by_campaign_id,
      sp_ppc_campaigns: state => state.ppc_settings.sp_ppc_campaigns
    }),
    ...mapGetters(["getCountryFlag"]),
    campaignGroupState() {
      const campaignGroupStateMap = {
        0: false,
        1: true,
        "-1": "inconsistent"
      };
      return campaignGroupStateMap[this.item.is_enabled ?? 1];
    },
    processedItem() {
      //console.log(this.item);
      //console.log(this.getCountryFlag(this.item.country_code));
      return {
        id: this.item.campaign_group_id,
        campaignIdList: this.item.campaign_id_list,
        isBlocked: this.item.is_blocked && this.item.is_blocked !== "false",
        name: this.item.campaign_group_name,
        image: this.item.campaign_group_image_link,
        flag: this.getCountryFlag(this.item.country_code),
        result: this.item.result,
        countryCode: this.item.country_code,
        subDetails: this.item.asin_count,
        daysInventory: this.item.days_inventory ? this.item.days_inventory * 1 : null,
        adsNetProfit4W: this.item.sponsored_net_profit,
        revShare4W: this.item.revenue_4w_share,
        productsMargin: this.item.asin_group_margin,
        productsMarginValue: this.item.asin_group_margin_value,
        boost: this.item?.boost ?? 1,
        cap: this.calculatedCapForMode[this.mode](this.item),
        //45, // TO-DO Need to calculate it
        acos4W: this.item.asin_group_4w_acos,
        roas4W: this.item.asin_group_4w_roas,
        perfomance: {
          budgetAi: this.item.perf_allocated_budget_ai,
          budgetCurrent: this.item.perf_allocated_budget_current,
          budgetCurrentEnabledCampaigns: this.item.perf_allocated_budget_current_enabled_campaigns,
          budgetPotential: this.item.perf_potential_budget ?? 7,
          isCustom: this.numberFormatter(this.item.perf_allocated_budget_current) !== this.numberFormatter(this.item.perf_allocated_budget_ai),
          potential: (this.item.is_enabled != 1 ? 0 : this.item?.perf_allocated_budget_current) / (this.item?.perf_potential_budget ?? 7),
          previous: (this.item.is_enabled != 1 ? 0 : this.item.perf_allocated_budget_current) - this.item.perf_previous_week_spend,
          previous_week_spend: this.item.perf_previous_week_spend,
          evolution: this.item.perf_budget_evolution,
          campaigns: this.item.campaign_details.filter(item => item.campaign_theme === "PERF").map(item => ({
            id: item.campaign_id,
            budgetAi: item?.allocated_budget_ai,
            budgetCurrent: item?.allocated_budget_current,
            budgetCalculated: item?.allocated_budget_current,
            budgetPotential: item.potential_budget ?? 7,
            evolution: item?.budget_evolution,
            potential: item.allocated_budget_current / item.potential_budget ?? 7,
            roas: item?.campaign_roas,
            maxRoas: this.item?.asin_group_4w_roas,
            maxAcos: this.item?.asin_group_4w_acos,
            name: item?.campaign_name,
            type: item?.campaign_type,
            previous_week_spend: item.previous_week_spend
          }))
        },
        discovery: {
          budgetAi: this.item?.discovery_allocated_budget_ai,
          budgetCurrent: this.item?.discovery_allocated_budget_current,
          budgetCurrentEnabledCampaigns: this.item.discovery_allocated_budget_current_enabled_campaigns,
          budgetCalculated: this.item?.discovery_allocated_budget_ai,
          budgetPotential: this.item?.discovery_potential_budget ?? 7,
          isCustom: this.numberFormatter(this.item?.discovery_allocated_budget_current) !== this.numberFormatter(this.item?.discovery_allocated_budget_ai),
          potential: (this.item.is_enabled != 1 ? 0 : this.item?.discovery_allocated_budget_current) / (this.item?.discovery_potential_budget ?? 7),
          previous: (this.item.is_enabled != 1 ? 0 : this.item?.discovery_allocated_budget_current) - this.item?.discovery_previous_week_spend,
          previous_week_spend: this.item?.discovery_previous_week_spend,
          evolution: this.item.discovery_budget_evolution,
          campaigns: this.item.campaign_details.filter(item => item.campaign_theme === "DISCOVERY").map(item => ({
            id: item.campaign_id,
            budgetAi: item.allocated_budget_ai,
            budgetCurrent: item.allocated_budget_current,
            budgetPotential: item.potential_budget ?? 7,
            evolution: item.budget_evolution,
            potential: item.allocated_budget_current / item.potential_budget ?? 7,
            roas: item.campaign_roas,
            maxRoas: this.item.asin_group_4w_roas,
            maxAcos: this.item.asin_group_4w_acos,
            name: item.campaign_name,
            type: item.campaign_type,
            previous_week_spend: item.previous_week_spend
          }))
        }
      };
    },
    currencySymbol() {
      return this.getCurrencySymbol();
    },
    getItemProductAds() {
      let product_ads_list = [];
      if (this.sp_product_ads_by_campaign_id.size) {
        this.item.campaign_id_list.forEach(campaign_id => {
          product_ads_list.push(this.sp_product_ads_by_campaign_id.get(campaign_id));
        });
        return this.getFormattedProductAds(product_ads_list?.flat().filter(element => !!element));
      }
    },
    getPausedProductAdsLength() {
      return this.getItemProductAds?.filter(product_ad => product_ad?.aggregated_state != 'ENABLED')?.length;
    },
    getRowClass() {
      const item = this.processedItem;
      const result = [];
      const classMap = {
        true: "ba-row-regular",
        false: "ba-row-paused",
        inconsistent: "ba-row-inconsistent"
      };
      result.push(classMap[this.campaignGroupState]);
      if (item.isBlocked) {
        result.push("ba-row-blocked");
      }
      return result;
    },
    getBadgeText() {
      const item = this.processedItem;
      let result = "";
      //console.log(item);

      if (item.isBlocked) {
        result = "Blocked";
      } else {
        result = this.badgeTextMapping[item.result] || "";
      }
      return result;
    },
    shouldDisplayBadge() {
      return !!this.getBadgeText;
    },
    getCap4W() {
      return this.mode == "acos" ? this.processedItem.acos4W : this.processedItem.roas4W;
    },
    getCapColor() {
      const cap = this.processedItem.cap * 1;
      let result = "";
      if (this.mode == "acos") {
        const value = this.processedItem.acos4W * 1;
        if (value <= cap) {
          result = "ba-text-green";
        } else if (value > 2 * cap) {
          result = "ba-text-red";
        } else if (value > 1.25) {
          result = "ba-text-yellow";
        }
      }
      if (this.mode == "roas") {
        const value = this.processedItem.roas4W * 1;
        if (value >= cap) {
          result = "ba-text-green";
        } else if (value < 0.5 * cap) {
          result = "ba-text-red";
        } else if (value < 0.8 * cap) {
          result = "ba-text-yellow";
        }
      }
      return result;
    },
    isBudgetModal() {
      return this.change_modal_type === "budget";
    }
  },
  methods: {
    ...mapActions(["ppcEditCampaign", "ppcProductPrioritizationCampaignGroupUpdate", "ppcProductPrioritizationCampaignEditUpdate"]),
    ...mapMutations(["ppcCampaignUpdateSet"]),
    onBlockToggle() {
      this.change_modal_text = `Are you sure you want to ${this.processedItem.isBlocked ? "UNBLOCK" : "BLOCK"} this campaign group?`;
      this.change_modal_type = "block";
      this.changeModal = true;
    },
    async onBlock() {
      this.changeModal = false;
      const item = {
        ...this.item
      };
      item.is_blocked = !item.is_blocked;
      this.onItemUpdate(item);
      await this.updateCampaignGroup(item.boost ?? 1, item.is_blocked);
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: 'advertisingBlockStatusChanged',
        properties: {}
      });
    },
    onApplyState(value) {
      if (this.edit_campaign_loading) {
        return;
      }
      this.updated_campaign_group_state = value;
      this.change_modal_text = `Are you sure you want to change the statuses of all campaigns in this group to ${value}?`;
      this.change_modal_type = "state";
      this.changeModal = true;
    },
    onApplyStateConfirm() {
      this.changeModal = false;
      this.edit_campaign_type = "block";
      this.edit_campaign_loading = true;
      this.editCampaign();
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: 'advertisingCampaignStatusChanged ',
        properties: {}
      });
    },
    campaignListToUpdateState() {
      let campaign_list = [];
      this.item.campaign_id_list.forEach(campaign_id => {
        campaign_list.push({
          ...this.sp_ppc_campaigns?.filter(item => item.campaignId?.toString() === campaign_id.toString())?.[0],
          campaign_id: campaign_id,
          profile_id: this.selected_profile_id,
          country_code: this.item.country_code,
          update_dict: {
            state: this.updated_campaign_group_state
          }
        });
      });
      return campaign_list;
    },
    campaignListToUpdateBudget() {
      let campaign_list = [];
      const campaigns = this.updated_budget.campaigns;
      campaigns.forEach(campaign => {
        campaign_list.push({
          ...this.sp_ppc_campaigns?.filter(item => item.campaignId?.toString() === campaign?.id.toString())?.[0],
          campaign_id: campaign?.id,
          profile_id: this.selected_profile_id,
          country_code: this.item.country_code,
          update_dict: {
            budget: {
              budgetType: "DAILY",
              budget: Math.round(campaign?.budgetCurrent / 7 * 100) / 100
            }
          }
        });
      });
      return campaign_list;
    },
    async editCampaign() {
      const campaignListMap = {
        block: this.campaignListToUpdateState,
        budget: this.campaignListToUpdateBudget
      };
      let campaign_list_to_update = campaignListMap[this.edit_campaign_type]();
      if (!campaign_list_to_update?.length) return;
      const payload = {
        workspace_id: this.current_workspace.workspace_id,
        campaign_group_id: this.item.campaign_group_id,
        campaign_list: campaign_list_to_update,
        task_type: "ppc_edit_campaign"
      };
      const data = await this.ppcEditCampaign(payload);
      if (data) {
        if (data.task_id === `${this.current_workspace.workspace_id}_${this.item.campaign_group_id}_ppc_edit_campaign`) {
          this.campaignEditTaskIdentifier = `${this.current_workspace.workspace_id}_${this.item.campaign_group_id}_ppc_edit_campaign`;
          this.executeTaskStatusHandler(data);
          this.checkTaskStatusPeriodically(this.campaignEditTaskIdentifier, 2000);
        }
      }
    },
    onItemUpdate(newItem) {
      this.$emit("item-update", newItem);
    },
    async onBoostChange(value) {
      const item = {
        ...this.item
      };
      item.boost = value;
      this.onItemUpdate(item);
      await this.updateCampaignGroup(item.boost, item.is_blocked);
    },
    onWeeklyEdit(type) {
      if (this.edit_campaign_loading) {
        return;
      }
      const fullType = type === "perf" ? "perfomance" : "discovery";
      if (this.processedItem[fullType].budgetAi !== "-" && this.processedItem[fullType].budgetCurrent !== "-") {
        const target = `weekly${type}${this.processedItem.id}`;
        const popups = document.querySelectorAll(".app-popup");
        popups.forEach(div => {
          const dataClasses = Array.from(div.classList).filter(cls => cls.startsWith("data-"));
          const secondParts = dataClasses.map(cls => cls.split("-")[1]);
          if (!secondParts.includes(target)) {
            document.getElementById(secondParts[0]).click();
          }
        });
        this.$emit("weekly-budget-edit", target);
        this.change_modal_data_type = fullType;
        this.change_modal_type = "budget";
        this.changeModal = true;
      }
    },
    onWeeklyReset(type) {
      if (this.edit_campaign_loading) {
        return;
      }
      const fullType = type === "perf" ? "perfomance" : "discovery";
      const updatedCampaigns = this.processedItem[fullType].campaigns;
      updatedCampaigns.forEach(campaign => {
        campaign.budgetCurrent = campaign.budgetAi;
      });
      this.updated_budget = {
        type: type,
        current: this.processedItem[fullType].budgetAi,
        campaigns: updatedCampaigns
      };
      this.edit_campaign_type = "budget";
      this.edit_campaign_loading = true;
      this.editCampaign();
    },
    onWeeklyEditPopupShown(target) {
      if (target.startsWith("weekly")) {
        this.weeklyBudgetShown = target;
      }
    },
    onWeeklyEditPopupHidden(target) {
      this.weeklyBudgetShown = null;
    },
    onWeeklyBudgetEditCancel() {
      document.getElementById(this.weeklyBudgetTarget).click();
      this.$emit("weekly-budget-edit", null);
      this.weeklyBudgetShown = null;
      this.onModalCancel();
    },
    onWeeklyBudgetEditApply(result) {
      document.getElementById(this.weeklyBudgetTarget)?.click();
      this.$emit("weekly-budget-edit", null);
      this.weeklyBudgetShown = null;
      this.onModalCancel();
      if (this.edit_campaign_loading) {
        return;
      }
      this.change_modal_text = `Are you sure you want to change the budget for ${result.type} targeting  to ${this.currencySymbol}${result.current}?`;
      this.change_modal_type = "budget_update";
      this.changeModal = true;
      this.updated_budget = result;
    },
    onApplyBudgetConfirm() {
      this.changeModal = false;
      this.edit_campaign_type = "budget";
      this.edit_campaign_loading = true;
      this.editCampaign();
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: 'advertisingCampaignBudgetUpdated',
        properties: {}
      });
    },
    getCurrencySymbol() {
      return currencies_symbols[this.currency];
    },
    aCOSCap(item) {
      return item?.asin_group_margin * Math.max(this.bid_settings?.non_branded_keyword_targeting ?? 0, this.bid_settings?.branded_keyword_product_targeting ?? 0, this.bid_settings?.competitor_product_targeting ?? 0) * (item.boost ?? 1);
    },
    rOASCap(item) {
      return 1 / this.aCOSCap(item);
    },
    async updateCampaignGroup(boost, is_blocked) {
      const payload = [{
        campaign_group_id: this.item.campaign_group_id,
        profile_id: this.selected_profile_id,
        country_code: this.item.country_code,
        campaign_group_name: this.item.campaign_group_name,
        sales_channel: this.item.sales_channel,
        asin_group: this.item.asin_group,
        boost: boost,
        is_blocked: is_blocked
      }];
      await this.ppcProductPrioritizationCampaignGroupUpdate(payload);
    },
    onModalCancel() {
      this.changeModal = false;
      this.change_modal_type = "";
      this.change_modal_data_type = "";
      this.change_modal_text = "";
    },
    onClosePopover(value) {
      document.getElementById(value).click();
    },
    getProductAdsGroupByType() {
      if (this.isSellerCentralAccount(this.selected_seller?.account_id)) return "sku";
      if (this.isVendorCentralAccount(this.selected_seller?.account_id)) return "asin";
    },
    getFormattedProductAds(product_ads) {
      const groupByKey = this.getProductAdsGroupByType();
      if (!groupByKey) return;
      return this.formatProductAds(product_ads, groupByKey);
    },
    formatProductAds(product_ads_list, groupByKey) {
      const product_ads_grouped = Object.groupBy(product_ads_list, entry => entry[groupByKey]);
      return Object.entries(product_ads_grouped).map(([key, entries]) => {
        const product_ads_details = entries;
        const states = new Set(entries.map(entry => entry.state));
        const aggregated_state = states.size === 1 ? [...states][0] : "MIXED";
        const product_ad_id_list = [...new Set(entries.map(entry => entry.adId))].sort();
        const campaign_id_list = this.item.campaign_id_list;
        const product_ad_group_id = product_ad_id_list.join("_");
        let asin_details = this.item.campaign_group_details.filter(detail_item => detail_item.asin === entries[0].asin)[0];
        const asin_name = asin_details?.asin_name ?? "";
        const asin_image = asin_details?.asin_image_link ?? "";
        const base = {
          product_ads_details,
          aggregated_state,
          product_ad_id_list,
          campaign_id_list,
          product_ad_group_id,
          asin_name,
          asin_image
        };
        if (groupByKey === "sku") {
          return {
            ...base,
            sku: key,
            asin: entries[0]?.asin
          };
        } else {
          return {
            ...base,
            asin: key
          };
        }
      });
    },
    checkIfAnyPreviousUpdateTaskIsRunning() {
      this.getAsyncUpdate(this.campaignEditTaskIdentifier);
      this.checkTaskStatusPeriodically(this.campaignEditTaskIdentifier, 2000);
    },
    handleIdle() {
      // this.edit_campaign_loading = false;
    },
    handleRunning() {
      this.edit_campaign_loading = true;
      this.checkTaskStatusPeriodically(this.campaignEditTaskIdentifier, 2000);
    },
    handleFailed(data) {
      this.edit_campaign_loading = false;
      this.edit_campaign_type = "";
      this.updated_budget = {};
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Campaign Edit Task failed \n" + data.task_result,
        delay: 60 // Show alert less than 60 secs
      });
      // throw new Error("Campaign Edit Task failed");
    },
    handleFinished(data) {
      this.ppcCampaignUpdateSet({
        'data': data.task_result,
        'campaign_group_id': this.item.campaign_group_id
      });
      this.edit_campaign_type = "";
      this.updated_budget = {};
      this.edit_campaign_loading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: "Campaign Edit Task has finished with success",
        delay: 60 // Show alert less than 60 secs
      });
    }
  }
};